import {
  deleteExternalCalendarEvent as _deleteExternalCalendarEvent,
  DeleteExternalCalendarEventResult,
} from '@griply/services';
import { DeleteCalendarEventInput } from '@griply/types';
import { httpsCallable } from 'firebase/functions';
import { getErrorReporter } from 'shared/services/error-tracking';

import { getFunctions } from './helpers';

export const deleteExternalCalendarEvent = async (
  payload: DeleteCalendarEventInput,
): Promise<DeleteExternalCalendarEventResult> => {
  try {
    return await _deleteExternalCalendarEvent({
      functions: getFunctions(),
      httpsCallable,
      payload,
    });
  } catch (error: unknown) {
    getErrorReporter().captureException(error, {
      tags: { source: 'external-calendars-delete-event' },
    });
    throw error;
  }
};
